export default __webpack_public_path__ + "static/media/1964.ef929092.png";